
(function () {

  if (window.TwoLaneHeader) return;

  var live = null;

  function forward(name) {
    return function (e) {
      if (live && live[name]) live[name](e);
    };
  }

  function init() {
    const megaMenuBtn = document.getElementById('mega-menu-btn');
    const burger      = document.getElementById('header-burger');
    const megaMenu    = document.getElementById('mega-menu');
    const megaClose   = document.getElementById('mega-menu-close');
    const overlay     = document.getElementById('header-overlay');
    const mainHeader  = document.getElementById('main-header');
    const topbar      = document.querySelector('.topbar');

    if (!megaMenu || !overlay) return;

    if (megaMenu.headerInit) return;
    megaMenu.headerInit = true;

    if (live && live.teardown) live.teardown();

    let openState = false;
    function isOpen() { return openState; }

    function setMenuPosition() {
      const navBar = document.querySelector('.nav-bar');
      let top;
      if (navBar && navBar.getClientRects().length) {
        top = Math.round(navBar.getBoundingClientRect().top);
      } else {
        top = mainHeader ? Math.round(mainHeader.getBoundingClientRect().bottom) : 0;
      }
      if (top < 0) top = 0;
      megaMenu.style.top    = top + 'px';
      megaMenu.style.height = 'calc(100vh - '  + top + 'px)';
      megaMenu.style.height = 'calc(100dvh - ' + top + 'px)';
      overlay.style.top     = top + 'px';
    }

    let menuLastFocused = null;
    let inertTimer = null;

    function clearInertTimer() {
      if (inertTimer) { clearTimeout(inertTimer); inertTimer = null; }
    }

    function focusable(el) {
      return !!(el && el.focus && document.contains(el) &&
                (el.offsetWidth || el.offsetHeight ||
                 (el.getClientRects && el.getClientRects().length)));
    }

    function returnFocus() {
      var target = focusable(menuLastFocused) && menuLastFocused !== document.body
        ? menuLastFocused
        : (focusable(burger) ? burger : (focusable(megaMenuBtn) ? megaMenuBtn : null));

      if (target) {
        target.focus({ preventScroll: true });
        return;
      }
      var active = document.activeElement;
      if (active && active.blur && megaMenu.contains(active)) active.blur();
    }

    function openMenu() {
      if (openState) return;
      openState = true;
      menuLastFocused = document.activeElement;
      clearInertTimer();
      megaMenu.removeAttribute('inert');
      if (window.TwoLaneA11y && window.TwoLaneA11y.lockScroll) window.TwoLaneA11y.lockScroll();
      setMenuPosition();
      requestAnimationFrame(setMenuPosition);
      megaMenu.classList.add('is-open');
      megaMenu.setAttribute('aria-hidden', 'false');
      overlay.classList.add('is-active');
      if (megaMenuBtn) megaMenuBtn.setAttribute('aria-expanded', 'true');
      if (burger) {
        burger.setAttribute('aria-expanded', 'true');
        burger.classList.add('is-open');
      }
      if (window.TwoLaneA11y) {
        window.TwoLaneA11y.focusFirst(megaMenu, '#mega-menu-close');
      }
    }

    function closeMenu() {
      if (!openState) return;
      openState = false;
      megaMenu.classList.remove('is-open');
      megaMenu.setAttribute('aria-hidden', 'true');
      overlay.classList.remove('is-active');
      if (megaMenuBtn) megaMenuBtn.setAttribute('aria-expanded', 'false');
      if (burger) {
        burger.setAttribute('aria-expanded', 'false');
        burger.classList.remove('is-open');
      }
      returnFocus();
      menuLastFocused = null;
      if (window.TwoLaneA11y && window.TwoLaneA11y.unlockScroll) window.TwoLaneA11y.unlockScroll();
      clearInertTimer();
      inertTimer = setTimeout(function () {
        inertTimer = null;
        if (!openState) megaMenu.setAttribute('inert', '');
      }, 300);
    }

    megaMenu.setAttribute('inert', '');

    let trapFn = null;
    function onTrapKeydown(e) {
      if (!window.TwoLaneA11y) return;
      if (!trapFn) trapFn = window.TwoLaneA11y.trap(megaMenu, isOpen);
      trapFn(e);
    }

    if (megaMenuBtn) megaMenuBtn.addEventListener('click', function () { openState ? closeMenu() : openMenu(); });
    if (burger)      burger.addEventListener('click',      function () { openState ? closeMenu() : openMenu(); });
    if (megaClose)   megaClose.addEventListener('click', closeMenu);
    overlay.addEventListener('click', function () { closeMenu(); closePanel(); });

    megaMenu.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', closeMenu);
    });

    const drawerBody = megaMenu.querySelector('.mega-menu__body');
    if (drawerBody) {
      drawerBody.addEventListener('toggle', function (e) {
        const d = e.target.closest && e.target.closest('.mega-menu__group');
        if (!d || !d.open) return;

        drawerBody.querySelectorAll('.mega-menu__group[open]').forEach(function (o) {
          if (o !== d) o.open = false;
        });

        const s = d.querySelector('summary');
        if (!s) return;
        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        drawerBody.scrollTo({
          top: drawerBody.scrollTop
             + (s.getBoundingClientRect().top - drawerBody.getBoundingClientRect().top) - 8,
          behavior: reduce ? 'auto' : 'smooth'
        });
      }, true);
    }

    function onPageShow(e) {
      if (e.persisted) closeMenu();
    }

    const triggers = document.querySelectorAll('[data-nav-trigger]');
    const panels   = document.querySelectorAll('[data-nav-panel]');
    const canHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    let openHandle = null;
    let hoverTimer = null;

    function panelFor(handle) {
      return document.querySelector('[data-nav-panel="' + handle + '"]');
    }

    function triggerFor(handle) {
      return document.querySelector('[data-nav-trigger="' + handle + '"]');
    }

    function nextBarLink(trigger) {
      const links = Array.prototype.slice.call(document.querySelectorAll('.nav-bar__links a[href]'));
      const i = links.indexOf(trigger);
      return i > -1 ? (links[i + 1] || null) : null;
    }

    function closePanel() {
      if (!openHandle) return;
      const panel = panelFor(openHandle);
      if (panel) {
        panel.classList.remove('is-open');
        setTimeout(function () {
          if (!panel.classList.contains('is-open')) panel.hidden = true;
        }, 160);
      }
      const trigger = document.querySelector('[data-nav-trigger="' + openHandle + '"]');
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
      openHandle = null;
    }

    function openPanel(handle) {
      if (openHandle === handle) return;
      closePanel();
      const panel = panelFor(handle);
      if (!panel) return;
      panel.hidden = false;
      requestAnimationFrame(function () { panel.classList.add('is-open'); });
      const trigger = document.querySelector('[data-nav-trigger="' + handle + '"]');
      if (trigger) trigger.setAttribute('aria-expanded', 'true');
      openHandle = handle;
    }

    function openIfRendered(handle) {
      openPanel(handle);
      const panel = panelFor(handle);
      if (openHandle === handle && panel && panel.getClientRects().length) return true;
      if (openHandle === handle) closePanel();
      return false;
    }

    function focusIntoPanel(handle) {
      requestAnimationFrame(function () {
        if (openHandle !== handle) return;
        const panel = panelFor(handle);
        const first = panel && panel.querySelector('a[href]');
        if (first) first.focus();
      });
    }

    triggers.forEach(function (trigger) {
      const handle = trigger.dataset.navTrigger;

      trigger.addEventListener('click', function (e) {
        if (openHandle !== handle && openIfRendered(handle)) {
          e.preventDefault();
        }
      });

      trigger.addEventListener('keydown', function (e) {
        if (e.altKey || e.ctrlKey || e.metaKey || e.shiftKey) return;
        const isEnter = e.key === 'Enter';
        if (!isEnter && e.key !== ' ' && e.key !== 'Spacebar' && e.key !== 'ArrowDown') return;
        if (openHandle === handle) {
          if (isEnter) return;
        } else if (!openIfRendered(handle)) {
          return;
        }
        e.preventDefault();
        focusIntoPanel(handle);
      });

      if (!canHover) return;

      trigger.addEventListener('mouseenter', function () {
        clearTimeout(hoverTimer);
        hoverTimer = setTimeout(function () { openPanel(handle); }, 90);
      });
    });

    if (canHover) {
      const navBar = document.querySelector('.nav-bar');
      if (navBar) {
        navBar.addEventListener('mouseleave', function () {
          clearTimeout(hoverTimer);
          hoverTimer = setTimeout(closePanel, 140);
        });
        navBar.addEventListener('mouseenter', function () { clearTimeout(hoverTimer); });
      }
    }

    function onFocusIn(e) {
      if (!openHandle) return;
      const panel = panelFor(openHandle);
      if (e.target === triggerFor(openHandle) || (panel && panel.contains(e.target))) return;
      closePanel();
    }

    function onDocClick(e) {
      if (openHandle && !e.target.closest('.nav-bar')) closePanel();
    }

    panels.forEach(function (panel) {
      panel.querySelectorAll('a').forEach(function (a) {
        a.addEventListener('click', closePanel);
      });

      panel.addEventListener('keydown', function (e) {
        if (e.key !== 'Tab' || e.altKey || e.ctrlKey || e.metaKey) return;
        const handle = panel.dataset.navPanel;
        if (handle !== openHandle) return;
        const links = panel.querySelectorAll('a[href]');
        if (!links.length) return;
        const trigger = triggerFor(handle);

        if (e.shiftKey && document.activeElement === links[0]) {
          if (!trigger) return;
          e.preventDefault();
          closePanel();
          trigger.focus();
        } else if (!e.shiftKey && document.activeElement === links[links.length - 1]) {
          const next = nextBarLink(trigger);
          if (!next) return;
          e.preventDefault();
          closePanel();
          next.focus();
        }
      });
    });

    function onEscape(e) {
      if (e.key !== 'Escape') return;
      if (openState) closeMenu();
      if (openHandle) {
        const panel = panelFor(openHandle);
        const trigger = triggerFor(openHandle);
        const wasInside = !!(panel && panel.contains(document.activeElement));
        closePanel();
        if (trigger && wasInside) trigger.focus();
      }
    }

    if (megaMenuBtn) megaMenuBtn.addEventListener('click', closePanel);
    if (burger)      burger.addEventListener('click', closePanel);

    function onResize() {
      if (openState) setMenuPosition();
    }

    function onScroll() {
      if (openState) return;
      const y = window.scrollY;
      if (mainHeader) mainHeader.classList.toggle('is-scrolled', y > 10);
      if (topbar) {
        if (y > 80)      topbar.classList.add('topbar--hidden');
        else if (y < 10) topbar.classList.remove('topbar--hidden');
      }
    }

    live = {
      megaMenu: megaMenu,
      onTrapKeydown: onTrapKeydown,
      onFocusIn: onFocusIn,
      onDocClick: onDocClick,
      onEscape: onEscape,
      onPageShow: onPageShow,
      onResize: onResize,
      onScroll: onScroll,
      teardown: function () {
        clearInertTimer();
        clearTimeout(hoverTimer);
        if (!openState) return;
        openState = false;
        if (window.TwoLaneA11y && window.TwoLaneA11y.unlockScroll) window.TwoLaneA11y.unlockScroll();
      }
    };
  }

  document.addEventListener('keydown', forward('onTrapKeydown'));
  document.addEventListener('focusin', forward('onFocusIn'));
  document.addEventListener('click',   forward('onDocClick'));
  document.addEventListener('keydown', forward('onEscape'));
  window.addEventListener('pageshow',  forward('onPageShow'));
  window.addEventListener('resize',    forward('onResize'), { passive: true });
  window.addEventListener('scroll',    forward('onScroll'), { passive: true });

  document.addEventListener('shopify:section:unload', function (e) {
    if (!live || !e.target.contains || !e.target.contains(live.megaMenu)) return;
    live.teardown();
    live = null;
  });

  document.addEventListener('shopify:section:load', function (e) {
    if (e.target.querySelector && e.target.querySelector('[data-header]')) init();
  });

  window.TwoLaneHeader = { init: init };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
